import React from 'react';
import './DownloadApp.css';

import { Heading } from '../../../components';
import { downloadApp } from '../../../constants';



const DownloadApp = () => {

  return (
    <section className="download-app">

      {/* App preview image */}
      <div className="image">
        <img src={downloadApp.image} alt="SwiftRide Mobile App" />
      </div>

      <div className="content">

        {/* Heading Section */}
        <Heading title={downloadApp.heading} subTitle={downloadApp.sub} linear sideHeading />

        {/* Description */}
        <p>{downloadApp.content}</p>

        <div className="download-container">

          {/* Download buttons */}
          <div className="btn-container">
            {downloadApp.buttons.map((button) => (
              <a key={button.id} href={button.link}>
                <img src={button.image} alt={button.alt} />
              </a>
            ))}
          </div>

          {/* Bar Code */}
          <div className="bar-code">
            <a href={downloadApp.qrCode.link}>
              <img src={downloadApp.qrCode.image} alt={downloadApp.qrCode.alt} />
            </a>
          </div>

        </div>

      </div>

    </section>
  );
};

export default DownloadApp;